module.exports = __webpack_public_path__ + "img/bl.1e302a28.svg";